'use strict';

/* Story In View Factory */

angular.module('storyApp').factory('storyInView',['$window', function($window) {

    var storyInView = {

        currentIndex: 0,
        onChange: null,

        getCurrentIndex: function() {
            var that = this;
            
            return that.currentIndex;
        },
        goTo: function(storyViewIndex) {

            var that = this;

            if (storyViewIndex !== that.currentIndex) {

                that.currentIndex = storyViewIndex;

                typeof that.onChange === 'function' && that.onChange(that.currentIndex);

            }
        }

    }

    return storyInView;

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/storyInView.js